import React from "react";

export const BANNER_SUBTITLE = (isVentureX: boolean) =>
  `Receive a complimentary fourth night when you book an eligible stay of at least four nights at select ${
    isVentureX ? "Premier and Lifestyle" : "Lifestyle"
  } Collection Hotels.`;

export const VIEW_TERMS_AND_DETAILS = (
  <a
    target="_blank"
    rel="noreferrer"
    href="https://travel.capitalone.com/terms/complimentary-night/"
  >
    View offer terms and details.
  </a>
);
export const VALID_THROUGH_MOBILE = "Offer valid through 12/31/2025.";

export const LOADING_POPUP_TITLE = "for premium stays";
export const LOADING_POPUP_SUBTITLE_VENTURE_X = (
  <ul>
    <li>Earn 10X miles on Premier & Lifestyle Collection Hotel bookings.</li>
    <li>
      Enjoy a $50 experience credit on Lifestyle Collection bookings and a $100
      experience credit on Premier Collection bookings.
    </li>
  </ul>
);
export const LOADING_POPUP_SUBTITLE_VENTURE = (
  <ul>
    <li>Earn 5X miles on Lifestyle Collection Hotel bookings.</li>
    <li>Enjoy a $50 experience credit on Lifestyle Collection bookings.</li>
  </ul>
);
